import { render, staticRenderFns } from "./ViewerImageOverlays.vue?vue&type=template&id=3ab8e962&scoped=true"
import script from "./ViewerImageOverlays.vue?vue&type=script&lang=js"
export * from "./ViewerImageOverlays.vue?vue&type=script&lang=js"
import style0 from "./ViewerImageOverlays.vue?vue&type=style&index=0&id=3ab8e962&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab8e962",
  null
  
)

export default component.exports